export default "__VITE_ASSET__68a893da__"